/**
 * T247 — Scorer marketplace API client.
 *
 * Customer endpoints (auth required, scoped to the logged-in user):
 *   getMyProfile()            → GET /api/marketplace/scorers/me/
 *   updateMyProfile(patch)    → PUT /api/marketplace/scorers/me/
 *   applyForListing()         → POST .../apply/
 *   withdrawListing()         → POST .../withdraw/
 *   uploadProfilePhoto(file)  → POST .../photo/  (multipart)
 *
 * Public endpoints (no auth):
 *   listScorers(filters)      → GET /api/marketplace/scorers/?...
 *   getScorer(id)             → GET /api/marketplace/scorers/<id>/
 */
import api from "./axios";

export const getMyProfile = () => api.get("/api/marketplace/scorers/me/");

export const updateMyProfile = (patch) =>
  api.put("/api/marketplace/scorers/me/", patch);

export const applyForListing = () =>
  api.post("/api/marketplace/scorers/me/apply/");

export const withdrawListing = () =>
  api.post("/api/marketplace/scorers/me/withdraw/");

export const uploadProfilePhoto = (file) => {
  const fd = new FormData();
  fd.append("photo", file);
  return api.post("/api/marketplace/scorers/me/photo/", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const listScorers = (filters = {}) => {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== "" && v != null) params.set(k, v);
  }
  const qs = params.toString();
  return api.get(`/api/marketplace/scorers/${qs ? "?" + qs : ""}`);
};

export const getScorer = (id) => api.get(`/api/marketplace/scorers/${id}/`);
